.host {
  display: flex;
  flex-direction: column;
  gap: 4rem;
  width: 100%;
  max-width: 39rem;
}

.form {
  position: relative;
}

.form .feedback {
  position: absolute;
  bottom: calc(100% + 1.4rem);
}

.form .fields {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
}

.digitsContainer {
  display: flex;
  gap: 2.4rem;
  align-items: flex-end;
  margin-bottom: 5rem;
}

.loaderIcon {
  min-width: 1.8rem;
  min-height: 1.8rem;
  margin-bottom: 0.8rem;
  color: var(--color-shadow-green);
}

.button {
  width: 100%;
  max-width: 16rem;
}

.resendContainer {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: auto;
  margin-bottom: 8.1rem;
}
